import {defineMessage} from 'react-intl'

export const SELECT_ROLE_HEADLINE_LINE1 = defineMessage({
    id: 'select_role.headline.line1',
    defaultMessage: 'Please select'
})

export const SELECT_ROLE_HEADLINE_LINE2 = defineMessage({
    id: 'select_role.headline.line2',
    defaultMessage: 'Role'
})
